module.exports = __webpack_public_path__ + "assets/img/returnBtn-3e84d3cc.png";